import { TextStyle } from "react-native";

import { ThemeStyle, ClassGroupType } from "../../Style.types";

export interface ITypographyClassGroup {
  fontPrimary: ThemeStyle;
  h1: ThemeStyle;
  h2: ThemeStyle;
  h3: ThemeStyle;
  h4: ThemeStyle;
  h5: ThemeStyle;
  h6: ThemeStyle;
  underline: TextStyle;
  b1Bold: ThemeStyle;
  b1Regular: ThemeStyle;
  b2Bold: ThemeStyle;
  b2Regular: ThemeStyle;
  b3Regular: ThemeStyle;
  b3Bold: ThemeStyle;
  l1Bold: ThemeStyle;
  l1Regular: ThemeStyle;
  l2Bold: ThemeStyle;
  l2Regular: ThemeStyle;
  l3Regular: ThemeStyle;
  l3Bold: ThemeStyle;
  l4Regular: ThemeStyle;
  l4Bold: ThemeStyle;
  textCenter: TextStyle;
  textRight: TextStyle;
  textLeft: TextStyle;
}

export const TypographyClassGroup: ClassGroupType<ITypographyClassGroup> = {
  fontPrimary: (theme) => ({
    fontFamily: theme.fonts.primary.regular,
  }),
  h1: (theme) => ({
    fontFamily: theme.fonts.primary.bold,
    color: theme.colors.neutralLighter.contrast,
    fontSize: theme.fonts.baseSize * 2.7,
    marginTop: 0,
  }),
  h2: (theme) => ({
    fontFamily: theme.fonts.primary.bold,
    color: theme.colors.neutralLighter.contrast,
    fontSize: theme.fonts.baseSize * 2.25,
    marginTop: 0,
  }),
  h3: (theme) => ({
    fontFamily: theme.fonts.primary.bold,
    color: theme.colors.neutralLighter.contrast,
    fontSize: theme.fonts.baseSize * 1.875,
    marginTop: 0,
  }),
  h4: (theme) => ({
    fontFamily: theme.fonts.primary.bold,
    color: theme.colors.neutralLighter.contrast,
    fontSize: theme.fonts.baseSize * 1.5,
    marginTop: 0,
  }),
  h5: (theme) => ({
    fontFamily: theme.fonts.primary.bold,
    color: theme.colors.neutralLighter.contrast,
    fontSize: theme.fonts.baseSize * 1.25,
    marginTop: 0,
  }),
  h6: (theme) => ({
    fontFamily: theme.fonts.primary.bold,
    color: theme.colors.neutralLighter.contrast,
    fontSize: theme.fonts.baseSize,
    marginTop: 0,
  }),
  b1Regular: (theme) => ({
    fontFamily: theme.fonts.primary.regular,
    color: theme.colors.neutralLighter.contrast,
    fontSize: theme.fonts.baseSize,
  }),
  b1Bold: (theme) => ({
    fontFamily: theme.fonts.primary.bold,
    fontWeight: "bold",
    color: theme.colors.neutralLighter.contrast,
    fontSize: theme.fonts.baseSize,
  }),
  b2Bold: (theme) => ({
    fontFamily: theme.fonts.primary.bold,
    fontWeight: "bold",
    color: theme.colors.neutralLighter.contrast,
    fontSize: theme.fonts.baseSize * 0.875,
  }),
  b2Regular: (theme) => ({
    fontFamily: theme.fonts.primary.regular,
    color: theme.colors.neutralLighter.contrast,
    fontSize: theme.fonts.baseSize * 0.875,
  }),
  b3Regular: (theme) => ({
    fontFamily: theme.fonts.primary.regular,
    color: theme.colors.neutralLighter.contrast,
    fontSize: theme.fonts.baseSize * 0.75,
  }),
  b3Bold: (theme) => ({
    fontFamily: theme.fonts.primary.bold,
    fontWeight: "bold",
    color: theme.colors.neutralLighter.contrast,
    fontSize: theme.fonts.baseSize * 0.75,
  }),

  underline: {
    textDecorationLine: "underline",
  },
  l1Bold: (theme) => ({
    fontFamily: theme.fonts.primary.bold,
    fontWeight: "bold",
    color: theme.colors.neutralLighter.contrast,
    fontSize: theme.fonts.baseSize,
  }),
  l1Regular: (theme) => ({
    fontFamily: theme.fonts.primary.regular,
    color: theme.colors.neutralLighter.contrast,
    fontSize: theme.fonts.baseSize,
  }),
  l2Bold: (theme) => ({
    fontFamily: theme.fonts.primary.bold,
    fontWeight: "bold",
    color: theme.colors.neutralLighter.contrast,
    fontSize: theme.fonts.baseSize * 0.875,
  }),
  l2Regular: (theme) => ({
    fontFamily: theme.fonts.primary.regular,
    color: theme.colors.neutralLighter.contrast,
    fontSize: theme.fonts.baseSize * 0.875,
  }),
  l3Regular: (theme) => ({
    fontFamily: theme.fonts.primary.regular,
    color: theme.colors.neutralLighter.contrast,
    fontSize: theme.fonts.baseSize * 0.75,
  }),
  l3Bold: (theme) => ({
    fontFamily: theme.fonts.primary.bold,
    fontWeight: "bold",
    color: theme.colors.neutralLighter.contrast,
    fontSize: theme.fonts.baseSize * 0.75,
  }),
  l4Regular: (theme) => ({
    fontFamily: theme.fonts.primary.regular,
    color: theme.colors.neutralLighter.contrast,
    fontSize: theme.fonts.baseSize * 0.65,
  }),
  l4Bold: (theme) => ({
    fontFamily: theme.fonts.primary.bold,
    fontWeight: "bold",
    color: theme.colors.neutralLighter.contrast,
    fontSize: theme.fonts.baseSize * 0.65,
  }),
  textCenter: {
    textAlign: "center",
  },
  textRight: {
    textAlign: "right",
  },
  textLeft: {
    textAlign: "left",
  },
};
